/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minifier_Pit3_DInputs */

const en_minifier_pit3_d = /** @type {(inputs: Minifier_Pit3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Running an already minified document through again returns it unchanged and reports zero savings. There is no second pass of redundancy to remove, because whitespace between tokens is the only thing minification touches.`)
};

const ko_minifier_pit3_d = /** @type {(inputs: Minifier_Pit3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이미 압축된 문서를 다시 통과시키면 그대로 반환되고 절감은 0으로 보고됩니다. 압축이 손대는 것은 토큰 사이의 공백뿐이므로, 제거할 두 번째 중복이 존재하지 않습니다.`)
};

const ja_minifier_pit3_d = /** @type {(inputs: Minifier_Pit3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すでに圧縮された文書をもう一度通すとそのまま返り、削減は 0 と報告されます。圧縮が触るのはトークン間の空白だけなので、取り除く二度目の冗長性が存在しません。`)
};

/**
* | output |
* | --- |
* | "Running an already minified document through again returns it unchanged and reports zero savings. There is no second pass of redundancy to remove, because wh..." |
*
* @param {Minifier_Pit3_DInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const minifier_pit3_d = /** @type {((inputs?: Minifier_Pit3_DInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minifier_Pit3_DInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_minifier_pit3_d(inputs)
	if (locale === "ko") return ko_minifier_pit3_d(inputs)
	return ja_minifier_pit3_d(inputs)
});